/**
 * NotFoundOrg - Página exibida quando o slug da organização não existe
 */

import { memo } from 'react';
import { Building2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const NotFoundOrg = memo(function NotFoundOrg() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4 dark:bg-zinc-950">
      <Card className="w-full max-w-md border-zinc-200 dark:border-zinc-800">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-zinc-100 dark:bg-zinc-900">
            <Building2 className="h-8 w-8 text-zinc-400 dark:text-zinc-500" />
          </div>
          <CardTitle className="text-xl text-zinc-900 dark:text-zinc-50">
            Organização não encontrada
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-sm text-zinc-500 dark:text-zinc-400">
            O endereço que você está tentando acessar não corresponde a nenhuma
            organização cadastrada.
          </p>
          <p className="mt-4 text-xs text-zinc-400 dark:text-zinc-500">
            Verifique o endereço digitado ou entre em contato com o
            administrador do sistema.
          </p>
        </CardContent>
      </Card>
    </div>
  );
});
